// extracted by mini-css-extract-plugin
module.exports = {"container":"Paragraph_container__36hQ9","contents":"Paragraph_contents__3Mije","text":"Paragraph_text__CQgwF"};